import { create } from 'zustand';
import type { CurrentUser } from '@pingo/api';

interface AuthState {
  isAuthenticated: boolean;
  user: CurrentUser | null;
  setUser: (user: CurrentUser) => void;
  clearAuth: () => void;
}

// 认证状态 Store（仅客户端状态）
export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  user: null,

  setUser: (user) => set({ isAuthenticated: true, user }),

  clearAuth: () => set({ isAuthenticated: false, user: null }),
}));
